import './radio.css'

function Radio({ options, name, value, defaultValue, handleOnChange }) {


    return (
        <div className="radio-div">

            {options.map((item) => (
                <div className="radio-option" key={item.value}>
                    <div className="radio-check-box" onClick={() => handleOnChange(name, item.value)}>
                        {value ? (item.value === value
                            ? <div className='radio-check-box-check radio-checked'>
                            </div>
                            : <div className='radio-check-box-check radio-unchecked'></div>
                        ) : (
                            item.value === defaultValue ?
                                <div className='radio-check-box-check radio-checked'>
                                </div>
                                : <div className='radio-check-box-check radio-unchecked'></div>
                        )}

                    </div>
                    <div className='radio-option-label'>
                        {item.label}
                    </div>
                </div>
            )

            )}
        </div>
    )
}

export default Radio

/* 
const options = [
        { value: 'fisica', label: "Pessoa física" },
        { value: 'juridica', label: "Pessoa jurídica" }
    ]


    <Radio
                            options={options}
                            name={"personType"}
                            value={client.personType}
                            defaultValue="fisica"
                            handleOnChange={handleChangeRadio}
                        />
*/